// extracted by mini-css-extract-plugin
export default {"span":"_span_qfND4"};